import { render, staticRenderFns } from "./createNews.vue?vue&type=template&id=6626213b&scoped=true&lang=html&"
import script from "./createNews.vue?vue&type=script&lang=js&"
export * from "./createNews.vue?vue&type=script&lang=js&"
import style0 from "./createNews.vue?vue&type=style&index=0&id=6626213b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626213b",
  null
  
)

export default component.exports